export const ERRORS = {
  CLAIMING_UNKNOWN_DEVICE: 'CLAIMING_UNKNOWN_DEVICE',
  UNEXPECTED: 'UNEXPECTED',
};
